import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import React, { useContext, useEffect } from 'react';
import { IEditVideoContext, EditVideoContext } from '../../editVideoState/editVideoContext';
import EditForm from './components/EditForm/EditForm';
import TranslationsForm from './components/TranslationsForm';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<IEditVideoContext>(EditVideoContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<WithAdditionalValidationState>
				<EditForm isVisible={visibleForm === 'mainForm'} />
				<TranslationsForm isVisible={visibleForm === 'translations'} />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Forms;
